import { Component, ViewChild } from '@angular/core';
import { MtxDatetimepickerType, MtxDatetimepickerMode, MtxCalendarView, MtxDatetimepicker, MtxDatetimepickerInput, MtxDatetimepickerToggle } from '@ng-matero/extensions/datetimepicker';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig } from '@ngx-formly/core';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'app-date-time-matero',
    templateUrl: './date-time-matero.component.html',
    styleUrls: ['./date-time-matero.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, MtxDatetimepickerInput, FormsModule, ReactiveFormsModule, MtxDatetimepickerToggle, MatSuffix, MtxDatetimepicker, TranslatePipe]
})
export class DateTimeMateroComponent extends FieldType<FieldTypeConfig> {
  //https://github.com/ng-matero/extensions

  @ViewChild('datetimePicker') datetimePicker: any;

  startView(math: any): MtxCalendarView {
    let startView: MtxCalendarView = math;

    return startView;
  }

  type(math: any): MtxDatetimepickerType {
    let type: MtxDatetimepickerType = math;

    return type;
  }

  mode(math: any): MtxDatetimepickerMode {
    let mode: MtxDatetimepickerMode = math;

    return mode;
  }

  agorDatepicker(): void {
    if (this.datetimePicker) {
      this.datetimePicker.open();
    }
  }
}
